import React from 'react';

// Import images
import whyChooseUs from "../assets/img/services/Why-Choose-us.png";
import artificialIntelligence from "../assets/img/services/Artificial-Intelligence.svg";
import mobileAppDevelopment from "../assets/img/mobile-app-development.webp";
import appDevelopmentServices from "../assets/img/services/App-development-services.png";
import microsoftDevelopment from "../assets/img/services/Microsoft-development.png";
import cloudConsulting from "../assets/img/services/cloud-consulting.png";
import webDesignUXUI from "../assets/img/services/webdesign-ux-ui.jpg";
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
  return (
    <div>
        <Header/>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Our Services</h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item active text-primary">Service</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* Service Start */}
      <div className="container-fluid service py-5">
        <div className="container py-5">
          <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{ maxWidth: '800px' }}>
            <h4 className="text-primary">Our Range Of Business Services</h4>
          </div>

          {/* Section 1 */}
          <div className="row epic-service-section epic-fade-in p-5 bg-white">
            <div className="col-md-4 d-flex justify-content-center">
              <img src={whyChooseUs} alt="Artificial Intelligence" className="img-fluid service-img" />
            </div>
            <div className="col-md-8 p-3">
              <h2 className="display-4 mb-4">We Provide Best Services</h2>
              <p className="mb-0 font-size-p">Empower your business with cutting-edge Artificial Intelligence solutions, intuitive Mobile App Development, and robust Application Development tailored to your needs.</p>
              <p className="mb-0 font-size-p">Enhance productivity with Microsoft Application Development, stunning Website Design & UI/UX Services, and seamless Cloud Consulting for scalable growth.</p>
              <p className="mb-0 font-size-p">Optimize operations with DevOps & Process Automation, while our Managed Services ensure security, efficiency, and uninterrupted business performance.</p>
            </div>
          </div>

          {/* Section 2 */}
          <div className="row epic-service-section epic-fade-in p-5">
            <div className="col-md-4 d-flex justify-content-center">
              <img src={artificialIntelligence} alt="Artificial Intelligence" className="img-fluid service-img" />
            </div>
            <div className="col-md-8 p-3">
              <h2>Artificial Intelligence</h2>
              <p className="font-size-p">Leverage AI to automate workflows, drive growth, and improve decisions. Our expertise in ML, NLP, and Predictive Analytics extracts insights. We deploy AI agents to streamline processes, manage tasks, and enhance customer service, data processing, and lead generation using Conversational, Generative, and Intelligent Task Automation for real-time decisions and productivity.</p>
            </div>
          </div>

          {/* Section 3 */}
          <div className="row epic-service-section flex-row-reverse epic-fade-in p-5 bg-white">
            <div className="col-md-4 d-flex justify-content-center">
              <img src={mobileAppDevelopment} alt="Mobile App Development" className="img-fluid service-img" />
            </div>
            <div className="col-md-8 p-3">
              <h2>Mobile App Development</h2>
              <p className="font-size-p">Expand your digital presence with custom mobile app development services for Android, iOS, and cross-platform solutions. We build high-performance, scalable, and user-friendly applications that enhance customer engagement and drive business success. Whether you need eCommerce apps, fintech solutions, healthcare applications, or enterprise mobility solutions, our team integrates the latest AI-powered automation, real-time analytics, and cloud technology to create seamless mobile experiences.</p>
            </div>
          </div>

          {/* Section 4 */}
          <div className="row epic-service-section epic-fade-in p-5">
            <div className="col-md-4 d-flex justify-content-center">
              <img src={appDevelopmentServices} alt="Application Development Services" className="img-fluid service-img" />
            </div>
            <div className="col-md-8 p-3">
              <h2>Application Development Services</h2>
              <p className="font-size-p">Enhance operational efficiency with our custom application development services, designed to meet your unique business needs. We develop enterprise software, SaaS applications, and business automation solutions using the latest technologies. Our expertise in frontend and backend development, API integrations, and cloud-based architecture ensures secure, high-performance, and scalable applications. Whether you need a business management system, CRM, or a data-driven application, we build solutions that drive growth.</p>
            </div>
          </div>

          {/* Section 5 */}
          <div className="row epic-service-section flex-row-reverse epic-fade-in p-5 bg-white">
            <div className="col-md-4 d-flex justify-content-center">
              <img src={microsoftDevelopment} alt="Microsoft Development" className="img-fluid service-img" />
            </div>
            <div className="col-md-8 p-3">
              <h2>Microsoft Development</h2>
              <p className="font-size-p">Microsoft development services encompass a wide range of technologies, including .NET, Azure, SharePoint, and Power BI. Organizations leverage Microsoft solutions for web applications, enterprise solutions, cloud services, and data analytics. With Microsoft’s vast ecosystem, businesses can achieve scalability, security, and integration with existing enterprise infrastructure.</p>
            </div>
          </div>

          {/* Section 6 */}
          <div className="row epic-service-section flex-row-reverse epic-fade-in p-5">
            <div className="col-md-4 d-flex justify-content-center">
              <img src={cloudConsulting} alt="Cloud Consulting" className="img-fluid service-img" />
            </div>
            <div className="col-md-8 p-3">
              <h2>Cloud Consulting</h2>
              <p className="font-size-p">Cloud computing has become a fundamental part of modern IT infrastructure, providing scalability, flexibility, and cost-efficiency. Cloud consulting services help businesses migrate to the cloud, optimize cloud resources, and implement secure and efficient cloud solutions. Whether it’s AWS, Azure, or Google Cloud, leveraging cloud technology ensures seamless operations and data management.</p>
            </div>
          </div>

          {/* Section 7 */}
          <div className="row epic-service-section epic-fade-in p-5 bg-white">
            <div className="col-md-4 d-flex justify-content-center">
              <img src={webDesignUXUI} alt="Website Design & UI/UX Services" className="img-fluid service-img" />
            </div>
            <div className="col-md-8 p-3">
              <h2>Website Design & UI/UX Services</h2>
              <p className="font-size-p">A well-designed website with an intuitive user experience is key to digital success. Website design and UI/UX services focus on creating visually appealing and user-friendly interfaces. From wireframing and prototyping to responsive web design and accessibility, a strong UI/UX strategy enhances customer engagement and conversion rates.</p>
            </div>
          </div>
        </div>
      </div>
      {/* Service End */}
      <Footer/>
    </div>
  );
};

export default ServicesPage;